import { ACTIONS } from '../actions/swikly'
import {
  CreateRequestResponse,
  GetRequestResponse,
  Request,
} from '../services/swikly'

/**
 * State interface for Swikly operations
 */
export interface SwiklyState {
  loading: boolean
  error?: any
  creationResponse?: CreateRequestResponse
  cautionDetails?: Request
}

const initialState: SwiklyState = {
  loading: false,
  error: null,
  creationResponse: undefined,
  cautionDetails: undefined,
}

/**
 * Reducer for Swikly operations
 * Handles state updates for creating cautions and getting caution status
 * @param state - Current state
 * @param action - Action to process
 * @returns Updated state
 */
const swiklyReducer = (state = initialState, action: any): SwiklyState => {
  switch (action.type) {
    case ACTIONS.CREATE_SWIKLY_CAUTION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case ACTIONS.CREATE_SWIKLY_CAUTION_SUCCESS:
      return {
        ...state,
        loading: false,
        creationResponse: action.payload,
        error: null,
      }

    case ACTIONS.CREATE_SWIKLY_CAUTION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      }

    case ACTIONS.GET_SWIKLY_CAUTION_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case ACTIONS.GET_SWIKLY_CAUTION_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        cautionDetails: action.payload.swik,
        error: null,
      }

    case ACTIONS.GET_SWIKLY_CAUTION_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      }

    default:
      return state
  }
}

export default swiklyReducer
